import React, { useRef } from 'react';
import './BlogDesktop.css';

const BlogDesktopCard = ({ blog }) => {
  const cardRef = useRef(null);

  const formattedDate = new Date(blog.publishedAt).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const handleCardClick = () => {
    window.open(blog.url, '_blank', 'noopener,noreferrer');
  };

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    cardRef.current.style.setProperty('--x', `${x}px`);
    cardRef.current.style.setProperty('--y', `${y}px`);
  };

  return (
    <article
      ref={cardRef}
      className="blog-desktop-card"
      onClick={handleCardClick}
      onMouseMove={handleMouseMove}
    >
      {blog.coverImage?.url && (
        <img
          className="card-image"
          src={blog.coverImage.url}
          alt={blog.title}
        />
      )}
      <div className="card-content">
        <div className="card-meta">
          <span className="card-category">
            { 'ARTICLE'}
          </span>
           / 
          <span className="card-date">{formattedDate}</span>
        </div>
        <h2 className="card-title">{blog.title}</h2>
        <p className="card-brief">
          {blog.subtitle ||
            `${blog.content.text.substring(0, 120)}...`}
        </p>
        <a
          href={blog.url}
          target="_blank"
          rel="noopener noreferrer"
          className="card-read-more"
          onClick={(e) => e.stopPropagation()}
        >
          READ MORE
        </a>
      </div>
    </article>
  );
};

export default BlogDesktopCard;
